import { createApi } from '@reduxjs/toolkit/query/react';
import config from '../../config/config';
import axiosBaseQuery from './axiosBaseQuery/axiosBaseQuery';
import type { APIHead, APIErrorItem } from './leaderBusinessBackgroundAPI';

export interface LeaderMultipleBusinessItem {
  primary: boolean;
  affiliateCode: number;
  aboNumber: number;
  name: string;
  localName: string;
  marketCountryCode: string;
  marketName: string;
  currentAward: {
    awardCode: string;
    awardName: string;
  };
}

export interface LeaderMultipleBusinessesResponse {
  statusCode: number;
  head: APIHead;
  body: LeaderMultipleBusinessItem[];
  error: APIErrorItem[];
}

export const leaderMultipleBusinessesAPI = createApi({
  reducerPath: 'leaderMultipleBusinessesAPI',
  baseQuery: axiosBaseQuery({
    baseUrl: config?.appUrl,
  }),
  keepUnusedDataFor: 900,
  tagTypes: ['LeaderMultipleBusinesses'],
  endpoints: (builder) => ({
    getLeaderMultipleBusinesses: builder.query<
      LeaderMultipleBusinessesResponse,
      UserSpecificArgTypes
    >({
      query: ({ affiliateCode, aboNumber }) => ({
        url: `/am/abo/${affiliateCode}/${aboNumber}/profile/multiplebusinesses`,
        method: 'GET',
      }),
      providesTags: (_result, _error, { affiliateCode, aboNumber }) => [
        { type: 'LeaderMultipleBusinesses', id: `${affiliateCode}-${aboNumber}` },
      ],
      transformResponse: (response: LeaderMultipleBusinessesResponse) =>
        response || ({} as LeaderMultipleBusinessesResponse),
    }),
  }),
});

export const { useGetLeaderMultipleBusinessesQuery } = leaderMultipleBusinessesAPI;
